module.exports = __webpack_public_path__ + "static/media/gear-white.90abe13a.svg";